import { computed } from 'vue'

import type { KanbanLogActor } from '@entities/kanban-comment'

import { useAdminRoutes } from '@shared/lib/routes'

interface KanbanLogItemInfoPayload {
  actor: KanbanLogActor | null
}

interface KanbanLogItemInfoReturn {
  refActorName: ComputedRef<string>
  refActorUrl: ComputedRef<string>
}

export const useKanbanLogItemInfo = (payload: KanbanLogItemInfoPayload): KanbanLogItemInfoReturn => {
  const refActorName = computed<string>(() => payload.actor?.name ?? '(System)')

  const refActorUrl = computed<string>(() => {
    if (!payload.actor) return ''
    return useAdminRoutes('admin.user.show', { user_id: payload.actor.id }) ?? ''
  })

  return {
    refActorName,
    refActorUrl,
  }
}